<ng-template #emergencyCodeModal let-params let-ref="modalRef">
    <span>Invia i dati richiesti per recuperare il codice di emergenza.</span>
    <nz-spin nzTip="Invio richiesta..." [nzSpinning] = "isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="emergencyCodeRecoverForm">
      <nz-form-item class="login">
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-form-control nzHasFeedback [nzValidateStatus]="username" [nzErrorTip]="getValidationErrorMessage(emergencyCodeRecoverForm.controls.username.errors)">
              <nz-input-group nzPrefixIcon="user" class="login">
                <input type="text" nz-input formControlName="username" placeholder="Username" />
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item class="login">
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-form-control 
            [nzErrorTip]="getValidationErrorMessage(emergencyCodeRecoverForm.controls.cfOPIva.errors)">
              <nz-input-group nzPrefixIcon="lock" class="login">
                <input nz-input formControlName="cfOPIva"
                i18n-placeholder="Auth.Generic.PlaceholderCfOOPiva|placeholder for cfOPIva in form@@Auth.Generic.PlaceholderCfOOPiva"
                placeholder="Codice fiscale o P.iva" />
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
    </form>
    </nz-spin>
  </ng-template>
  
  <ng-template #emergencyCodeFooter>
    <button nz-button nzType="primary" (click)="onRecoveryEmergencyCodeChange()" [nzLoading]="isSpinning" [disabled]="!emergencyCodeRecoverForm.valid">INVIA</button>
  </ng-template>
